import type { FormEventHandler, ReactNode } from 'react';
import { useTranslation } from 'utils/i18n';

// Components
import InstructionalFormActions from '../../instructionalForm/actions';

interface Props {
  children: ReactNode;
  handleSubmit: FormEventHandler<HTMLFormElement>;
  submissionErrors?: string[];
  isValid: boolean;
  handleGoBack?: () => void;
  showBackBtn?: boolean;
  handleCancel?: () => void;
  showCancelButton?: boolean;
  title?: string;
  previousStep?: number;
}

const ServiceDetailsContainer = ({
  children,
  handleSubmit,
  submissionErrors,
  isValid,
  handleGoBack,
  showBackBtn = true,
  handleCancel,
  showCancelButton = false,
  title,
  previousStep = 2,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <form
      className="instructional-form__form"
      onSubmit={handleSubmit}
      data-testid="serviceDetailsForm"
      data-cy="serviceDetailsForm"
    >
      <h2 data-cy="registrationHeader">
        {title || t('registration.service_details.title')}
      </h2>

      {children}

      {submissionErrors && submissionErrors.length > 0 && (
        <div className="registration-submission-errors">
          <p>{t('registration.service_details.submission_failed')}</p>
          <ul>
            {submissionErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      <InstructionalFormActions
        isValid={isValid}
        showBackBtn={showBackBtn}
        submitBtnText={t('registration.service_details.submit_for_approval')}
        backBtnText={t('back_to_step', { step: previousStep })}
        handleBackBtnClick={handleGoBack}
        // This was passed as `handleCancleBtnClick` (sic), so the cancel
        // button silently no-opped; the `as any` spread hid the typo.
        handleCancelBtnClick={handleCancel}
        showCancelBtn={showCancelButton}
      />
    </form>
  );
};

export default ServiceDetailsContainer;
